import React, { useState, useEffect } from "react";
import { Card, Col, Row, Button } from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import { getAllBrokers } from "services/services";
import { dateformat } from "admin/commonFunction";
import { Spinner } from "reactstrap";

const BrokerDetail = () => {
  const { brokerId } = useParams();
  const history = useHistory();
  const [brokerData, setBrokerData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrokerDetail = async () => {
      try {
        setLoading(true);
        const res = await getAllBrokers(1, 10, "", "", "", "", "", "false");
        const allBrokers = res?.data?.brokers || res?.data?.items || [];
        const found = allBrokers.find((item) => item._id === brokerId);
        setBrokerData(found || null);
      } catch (err) {
        console.error("Failed to fetch broker", err);
        setBrokerData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchBrokerDetail();
  }, [brokerId]);

  const handleNavigate = (path) => {
    history.push(`/admin/brokers/${brokerId}/${path}`);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center items-center p-10">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!brokerData) {
    return <div className="p-10 text-center text-danger">❌ Broker not found</div>;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row className="mb-3">
          <Col lg="12" className="d-flex justify-content-end gap-2">
            <Button
              color="primary"
              outline
              onClick={() => handleNavigate('agents')}
            >
              Agents ({brokerData.agentCount || 0})
            </Button>
            <Button
              color="primary"
              outline
              onClick={() => handleNavigate('properties')}
            >
              Properties
            </Button>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            {/* Broker Summary Card */}
            <Card className="mb-4 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="card-title mb-0">Broker Details</h4>
                  <div>
                    Status:{" "}
                    <span
                      className={`badge ${
                        brokerData.isBlocked ? "bg-danger" : "bg-success"
                      }`}
                    >
                      {brokerData.isBlocked ? "Blocked" : "Active"}
                    </span>
                  </div>
                </div>

                <Row>
                  {/* Left Info Section */}
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={brokerData.profilePicture || "/default-avatar.png"}
                        alt="Broker Profile"
                        className="rounded-circle me-3"
                        style={{ width: "80px", height: "80px", objectFit: "cover" }}
                      />
                      <div>
                        <h5 className="mb-1">{brokerData.companyName}</h5>
                        <p className="text-muted mb-0">
                          License: {brokerData.licenseNumber || "N/A"}
                        </p>
                      </div>
                    </div>

                    <h6 className="text-uppercase fw-bold mb-3">Contact Information</h6>
                    <div className="mb-2">
                      <strong>Email:</strong>{" "}
                      <a href={`mailto:${brokerData.email}`}>{brokerData.email}</a>
                    </div>
                    <div className="mb-2">
                      <strong>Phone:</strong> {brokerData.phoneNumber || "N/A"}
                    </div>
                    <div className="mb-2">
                      <strong>Website:</strong>{" "}
                      {brokerData.url ? (
                        <a href={brokerData.url} target="_blank" rel="noopener noreferrer">
                          {brokerData.url}
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    <div className="mb-2">
                      <strong>Office Address:</strong> {brokerData.officeAddress || "N/A"}
                    </div>
                  </Col>

                  {/* Right Info Section */}
                  <Col md={6} className="mb-4">
                    <h6 className="text-uppercase fw-bold mb-3">Business Details</h6>
                    <div className="mb-2">
                      <strong>Specialties:</strong> {brokerData.speacialties || "N/A"}
                    </div>
                    <div className="mb-2">
                      <strong>Timezone:</strong> {brokerData.timezone || "N/A"}
                    </div>
                    <div className="mb-2">
                      <strong>Created:</strong> {dateformat(brokerData.createdAt)}
                    </div>

                    <h6 className="text-uppercase fw-bold mt-4 mb-3">Business Hours</h6>
                    <Row>
                      {Object.entries(brokerData.businessHours || {}).map(([day, hours]) => (
                        <Col xs={6} key={day} className="mb-2">
                          <div className="d-flex justify-content-between">
                            <span className="text-capitalize fw-semibold">{day}:</span>
                            <span>
                              {hours.enabled ? (
                                `${hours.from} - ${hours.to}`
                              ) : (
                                <span className="text-muted">Closed</span>
                              )}
                            </span>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BrokerDetail;
